import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import { errorMsg, refreshToken } from 'utils';
import axios from 'axios';

export const WEB_MENUS_FETCH = createAction('WEB_MENUS_FETCH');
export const WEB_MENUS_FETCH_DATA_SUCCESS = createAction('WEB_MENUS_FETCH_DATA_SUCCESS');
export const WEB_MENUS_FETCH_DATA_FAIL = createAction('WEB_MENUS_FETCH_DATA_FAIL');

export const WEB_MENUS_DELETE_INIT = createAction('WEB_MENUS_DELETE_INIT');
export const WEB_MENUS_DELETE_SUCCESS = createAction('WEB_MENUS_DELETE_SUCCESS');
export const WEB_MENUS_DELETE_FAIL = createAction('WEB_MENUS_DELETE_FAIL');

export const WEB_MENUS_CREATE_INIT = createAction('WEB_MENUS_CREATE_INIT');
export const WEB_MENUS_CREATE_SUCCESS = createAction('WEB_MENUS_CREATE_SUCCESS');
export const WEB_MENUS_CREATE_FAIL = createAction('WEB_MENUS_CREATE_FAIL');

export const WEB_MENUS_MODIFY_INIT = createAction('WEB_MENUS_MODIFY_INIT');
export const WEB_MENUS_MODIFY_SUCCESS = createAction('WEB_MENUS_MODIFY_SUCCESS');
export const WEB_MENUS_MODIFY_FAIL = createAction('WEB_MENUS_MODIFY_FAIL');

export const WEB_MENUS_CLEAN_UP = createAction('WEB_MENUS_CLEAN_UP');
export const WEB_MENUS_CLEAR_DATA_LOGOUT = createAction('WEB_MENUS_CLEAR_DATA_LOGOUT');

export const fetchWebMenus = ({ siteId }) => async (dispatch) => {
  dispatch(WEB_MENUS_FETCH());
  try {
    const token = await refreshToken();
    const res = await axios.get(`${url}/webMenus/list/${siteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return dispatch(WEB_MENUS_FETCH_DATA_SUCCESS({ list: res.data.data || [] }));
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_MENUS_FETCH_DATA_FAIL({ error }));
  }
};

export const addWebMenus = (data, callback) => async (dispatch) => {
  dispatch(WEB_MENUS_CREATE_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.post(`${url}/webMenus/create`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Menu created successfully');
    dispatch(WEB_MENUS_CREATE_SUCCESS({ menu: res.data.data }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_MENUS_CREATE_FAIL({ error }));
  }
};

export const updateWebMenus = (id, data, callback) => async (dispatch) => {
  dispatch(WEB_MENUS_MODIFY_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.put(`${url}/webMenus/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Menu updated successfully');
    dispatch(WEB_MENUS_MODIFY_SUCCESS({ menu: res.data.data, id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_MENUS_MODIFY_FAIL({ error }));
  }
};

export const deleteWebMenu = ({ id, siteId }, callback) => async (dispatch) => {
  dispatch(WEB_MENUS_DELETE_INIT());
  try {
    const token = await refreshToken();
    await axios.delete(`${url}/webMenus/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Menu deleted successfully');
    dispatch(WEB_MENUS_DELETE_SUCCESS({ id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_MENUS_DELETE_FAIL({ error }));
  }
};
